import { Controller } from "@hotwired/stimulus"

// Jump to a piece's review frame (#reviews_section_<id>) and keep it pinned
// while late-loading content above it — lazy review frames, product photos —
// streams in and reflows the page, which would otherwise leave the viewport
// on the wrong piece. Pins via rAF until the deadline (extended while review
// frames are still loading), or until the user scrolls away themselves.
// Connects to data-controller="reviews-jump"
const PIN_MS = 2000
const PIN_HARD_CAP_MS = 10000

export default class extends Controller {
  jump(event) {
    const id = this.element.getAttribute("href").slice(1)
    const target = document.getElementById(id)
    if (!target) return

    event.preventDefault()
    history.pushState(null, "", `#${id}`)

    this.pinning = true
    const stop = () => { this.pinning = false }
    addEventListener("wheel", stop, { passive: true, once: true })
    addEventListener("touchstart", stop, { passive: true, once: true })

    const started = Date.now()
    const tick = () => {
      if (!this.pinning) return

      const elapsed = Date.now() - started
      const framesPending = [...document.querySelectorAll('turbo-frame[id^="reviews_section_"]')]
        .some(frame => !frame.complete)
      if (elapsed > PIN_HARD_CAP_MS || (elapsed > PIN_MS && !framesPending)) return

      target.scrollIntoView()
      requestAnimationFrame(tick)
    }
    tick()
  }
}
